import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import TemplateAPI from "../../api/TemplateAPI";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useTemplates = () => {
  const tenantID = useAtomValue(tenantIDAtom);

  const templates = useQuery({
    queryKey: ["templates", tenantID],
    queryFn: () =>
      TemplateAPI.getCRMTemplates().then((data) => data.data.data.templates),
  });

  return {
    templates: templates.data,
    templatesLoading: templates.isLoading,
    templatesError: templates.error,
  };
};

export default useTemplates;
